import React from 'react'
import { Card, Form, Input, Select, Typography } from 'antd'
import { thousandSeparator, unThousandSeparator } from 'helpers/numbers'
import { FormikState } from 'formik'
import { LoyaltyRequestPointDisbursementRequest } from 'generated/api'
import { regexNumber } from 'constants/regex'

interface IProps {
  departmentData: { value: string; label: string }[]
  disbursementTypes: { value: string; label: string }[]
  formData?: FormikState<LoyaltyRequestPointDisbursementRequest>
  onDepartment: (val: string) => void
  onDisbursementTypeId: (val: string) => void
  onPurpose: (val: string) => void
  onTitle: (val: string) => void
  onDescription: (val: string) => void
  onPoint: (val: number) => void
}

export default function FormSawitPoinInfo(props: Readonly<IProps>) {
  const {
    departmentData,
    disbursementTypes,
    formData,
    onDepartment,
    onDisbursementTypeId,
    onPurpose,
    onTitle,
    onDescription,
    onPoint,
  } = props

  const handleChangeDepartment = (value: string) => {
    onDepartment(value)
  }

  const handleChangeDisbursement = (value: string) => {
    onDisbursementTypeId(value)
  }

  return (
    <Card data-testid="card-sawitpoin-info">
      <div className="xl:w-2/5 xl:flex w-full">
        <h3 className="m-0 text-xl text-[#323539] self-center">1. Informasi Permintaan</h3>
      </div>
      <Form>
        <div className="grid grid-cols-2 gap-5 mt-5">
          <div className="w-full">
            <Typography.Text>Department</Typography.Text>
            <Select
              data-testid="select-department-sawitpoin"
              placeholder="Pilih department"
              className="w-full mt-2"
              onChange={handleChangeDepartment}
              size="large"
              value={
                formData?.values?.department?.length == 0
                  ? 'Pilih Department'
                  : formData?.values?.department
              }
            >
              {departmentData.map(status => {
                return (
                  <Select.Option
                    data-testid={`select_department_${status.value}`}
                    key={status.value}
                    value={status.value}
                  >
                    {status.label}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
          <div className="w-full">
            <Typography.Text>Jenis Pencairan</Typography.Text>
            <Select
              data-testid="select-melt-sawitpoin"
              placeholder="Pilih jenis pencairan"
              className="w-full mt-2"
              onChange={handleChangeDisbursement}
              size="large"
              value={
                formData?.values?.disbursementTypeId?.length == 0
                  ? 'Pilih Jenis Pencairan'
                  : formData?.values?.disbursementTypeId
              }
            >
              {disbursementTypes.map(status => {
                return (
                  <Select.Option
                    data-testid={`select_disbursement_${status.value}`}
                    key={status.value}
                    value={status.value}
                  >
                    {status.label}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
        </div>
        <div className="grid grid-rows-3 grid-flow-col gap-5 mt-5">
          <div className="row-span-3">
            <Typography.Text>Tujuan pencairan</Typography.Text>
            <Input.TextArea
              data-testid="input-subject-melt"
              className="mt-2"
              rows={4}
              placeholder="Tulis alasan"
              value={formData?.values.purpose}
              onChange={({ target: { value } }) => {
                onPurpose(value)
              }}
            />
          </div>
          <div className="row-span-3">
            <Typography.Text>Judul Pencairan SawitPoin</Typography.Text>
            <Input.TextArea
              data-testid="input-title-melt"
              className="mt-2"
              rows={4}
              placeholder="Tulis alasan"
              value={formData?.values.title}
              onChange={({ target: { value } }) => {
                onTitle(value)
              }}
            />
          </div>
          <div className="row-span-3">
            <Typography.Text>Deskripsi Pencairan SawitPoin</Typography.Text>
            <Input.TextArea
              data-testid="input-desc-melt"
              className="mt-2"
              rows={4}
              placeholder="Tulis alasan"
              value={formData?.values.description}
              onChange={e => {
                onDescription(e.currentTarget.value)
              }}
            />
          </div>
        </div>
        <div className="mt-5">
          <Typography.Text>Jumlah SawitPoin</Typography.Text>
          <Input
            data-testid="input-total-sawitpoin"
            size="large"
            className="mt-2"
            placeholder="2.000"
            maxLength={9}
            value={formData?.values.point ? thousandSeparator(formData?.values.point) : ''}
            onChange={({ target: { value } }) => {
              const val = unThousandSeparator(value)
              if (regexNumber.test(val)) {
                onPoint(Number(val))
              }
            }}
          />
        </div>
      </Form>
    </Card>
  )
}
